<template>
  <v-row class="pt-5" v-if="doc">
    <v-col cols="6" offset="3">
      <v-row>
        <v-col
          v-for="item in doc.selectedList"
          :key="item.id"
          :data-id="item.id"
          cols="12"
        >
          <v-card light>
            <v-card-title>
              {{ item.title }}
            </v-card-title>
            <v-card-subtitle>
              <p>{{ item.description }}</p>
              <v-chip :color="colorClass(item.value)">{{ item.value }}</v-chip>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");

export default {
  name: "ResultsFunctionalityUser",
  data() {
    return {
      doc: null,
      cols: 4,
    };
  },
  props: {
    uid: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise(val);
      }
    },
  },
  mounted() {
    this.getExercise(this.uid);
  },
  methods: {
    getExercise(id) {
      this.doc = null;
      // get a ref to the exercise and listen to changes
      let ref = fb.keywordsExCollection.where("uid", "==", id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.doc = items[0];
          }
        })
        .catch(function() {});
    },
    colorClass(val) {
      switch (val) {
        case "5":
          return "green accent-1";
        case "10":
          return "green accent-2";
        case "25":
          return "green accent-3";
        case "50":
          return "green accent-4";
      }
    },
  },
};
</script>
